var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product.summary)?_c('div',{staticClass:"buying-zone__positioning-statement mb-2 pt-2 border-t border-gray-10"},[_c('p',{attrs:{"qaid":"product-summary"}},[_vm._v(_vm._s(_vm.product.summary))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }